// extracted by mini-css-extract-plugin
export default {"title":"styles_title__-w7wU","form":"styles_form__7mTd9","containerButtons":"styles_containerButtons__6tIw-","cancelButton":"styles_cancelButton__U5mxP"};